import React from "react";
import BlogFormPage from "../components/blogs/BlogFormPage";

const BlogEdit = () => <BlogFormPage mode="edit" />;

export default BlogEdit;
